import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  tag: {
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
}));

const Tags = ({ tags }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      {tags.map(({ title, list }) => (
        <div className={classes.tag} key={title}>
          <Typography variat="h5" className={classes.title}>
            {title}
          </Typography>
          <Grid container spacing={2}>
            {list.map(item => (
              <Grid item key={item}>
                <Chip label={item} />
              </Grid>
            ))}
          </Grid>
        </div>
      ))}
    </Paper>
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      list: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    }).isRequired,
  ).isRequired,
};

export default Tags;
